exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".average{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999;background:#fff}.average__close{position:absolute;z-index:100;right:15px;top:15px;font-size:2em;color:#000;transition:color .2s ease}.average__close:hover{color:#00c6b5}", ""]);

// exports
